import React, { useState, useContext } from "react";
import { MovieContext } from "../app-context/MovieContext";

const SearchBar = () => {
  const [title, setTitle] = useState("");
  const { fetchMovies } = useContext(MovieContext);

  const handleSearch = () => {
    fetchMovies(title);
  };

  return (
    <div className="my-4 flex justify-center">
      <input
        type="text"
        placeholder="Search for movies..."
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="p-2 border border-gray-300 rounded"
      />
      <button
        onClick={handleSearch}
        className="ml-2 p-2 bg-red-500 text-white rounded"
      >
        Search
      </button>
    </div>
  );
};

export default SearchBar;
